import { SOCKET_UPDATE_STEPS } from 'modules/sockets/constants';

import Flow from 'types/Flow';
import { SelfServiceAPISteps, SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import { shouldDisplayMobilityParking } from 'modules/selfServices/selectors';

import Parking from 'components/Parking';
import ParkingInstruction from 'components/Parking/ParkingInstruction';

import { HomeCheckOutSteps } from './home';
import { FINAL_INSTRUCTIONS } from '../common';
import type { SelfServiceStep } from '../../types';
import { hasParking, isNotAnswered } from '../utils';
import { FINAL_INVOICE, SUMMARY, SIGNATURE } from './common';

export const PARKING: SelfServiceStep = {
  key: SelfServiceSteps.PARKING,
  apiKey: SelfServiceAPISteps.CUSTOMER_CAR_INFO,
  component: ParkingInstruction,
  title: {
    id: 'parking.title',
    defaultMessage: 'Parking',
  },
  previous: FINAL_INVOICE.key,
  data: {
    isVisible: ({ status, parking }) => isNotAnswered(status) && hasParking(parking),
    socketUpdateFields: SOCKET_UPDATE_STEPS.PARKING,
  },
};

export const MOBILITY_PARKING: SelfServiceStep = {
  key: SelfServiceSteps.MOBILITY_PARKING,
  apiKey: SelfServiceAPISteps.COURTESY_CAR_PARKING,
  component: Parking,
  title: (selfService) => {
    const isMobility = shouldDisplayMobilityParking(selfService);
    return {
      id: isMobility ? 'parking.mobility.title' : 'parking.title',
      defaultMessage: isMobility ? 'Courtesy vehicle parking' : 'Parking',
    };
  },
  previous: PARKING.key,
  data: {
    isVisible: ({ status, mobilityEnabled, parkingMap }) => (
      isNotAnswered(status) && mobilityEnabled && (parkingMap?.allowParkingSpot || parkingMap?.maps?.length > 0)
    ),
  },
};

export type OnSiteCheckOutSteps =
  HomeCheckOutSteps
  | SelfServiceSteps.PARKING
  | SelfServiceSteps.MOBILITY_PARKING
  | SelfServiceSteps.SIGNATURE;

const ON_SITE_CHECK_OUT_STEPS: Flow<OnSiteCheckOutSteps> = {
  SUMMARY,
  FINAL_INVOICE,
  PARKING: {
    ...PARKING,
    next: MOBILITY_PARKING.key,
  },
  MOBILITY_PARKING: {
    ...MOBILITY_PARKING,
    next: SIGNATURE.key,
  },
  SIGNATURE: {
    ...SIGNATURE,
    previous: MOBILITY_PARKING.key,
    next: FINAL_INSTRUCTIONS.key,
    data: {
      ...SIGNATURE.data,
      isFinalizeStep: true,
    },
  },
  FINAL_INSTRUCTIONS: { ...FINAL_INSTRUCTIONS, previous: SIGNATURE.key },
};

export default ON_SITE_CHECK_OUT_STEPS;
